'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Record } from 'immutable';
import { fromNetwork } from '../ad-management/BudgetRecord';
import { fromMillis } from '../ad-management/ScheduleRecord';
import I18n from 'I18n';
import Raven from 'raven-js';
import { Networks } from 'AdsUI/lib/Constants';
import { BiddingStrategyInfoRecord } from '../ad-management/AdCreationRecord';
export default class ReportingCampaignRecord extends Record({
  id: null,
  accountId: null,
  name: null,
  network: null,
  status: null,
  budget: null,
  schedule: null,
  type: null,
  previousState: null,
  startTime: null,
  endTime: null,
  manageable: true,
  effectiveStatus: null,
  keyResultSource: null,
  biddingStrategyInfo: BiddingStrategyInfoRecord()
}) {
  constructor(_ref) {
    let {
      budget
    } = _ref,
        data = _objectWithoutPropertiesLoose(_ref, ["budget"]);

    super(Object.assign({}, data, {
      budget: budget && fromNetwork(budget),
      schedule: fromMillis(data.startTime, data.endTime)
    }));
  }

  getFormattedType() {
    if (!this.type || this.network === Networks.LINKEDIN) return '--';
    const key = this.network === Networks.FACEBOOK ? `facebookGlobal.campaignObjective.${this.type}` : `adwordsGlobal.campaignType.${this.type.toLowerCase()}`;

    if (this.type === 'UNKNOWN') {
      Raven.captureMessage('Missing campaign type or object mapping', {
        level: 'info',
        extra: {
          adAccount: this.toJSON()
        }
      });
    }

    return I18n.text(key);
  }

}